import { render, staticRenderFns } from "./LoginSvg.vue?vue&type=template&id=612fafdb&scoped=true&"
import script from "./LoginSvg.vue?vue&type=script&lang=js&"
export * from "./LoginSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fafdb",
  null
  
)

export default component.exports